<template>
    <div>
        <block-banner image="3">
            <text-headline-primary class="headline">
                {{ texts.title }}
            </text-headline-primary>
            <p class="text">
                {{ texts.description }}
            </p>
        </block-banner>
        <block-section>
            <breadcrumb />
            <layout-single>
                <div class="products">
                    <product-card
                        v-for="product in products"
                        :key="product.id"
                        :product="product"
                        class="product"
                    />
                </div>
            </layout-single>
        </block-section>
    </div>
</template>

<script>
import { mapState } from "vuex";
import BlockBanner from "../components/blocks/BlockBanner";
import ProductCard from "../components/blocks/BlockFixedPriceProductCard";

export default {
    components: {
        BlockBanner,
        ProductCard
    },
    computed: {
        texts() {
            return this.$t("page_fixed_price_products");
        },
        ...mapState({
            products: state => state.products.fixedpriceticket.info.products
        })
    },
    created() {
        this.$store.dispatch("flow/startFixedPriceTicketFlow", {
            product: null
        });
    }
};
</script>

<style scoped lang="scss">
.headline {
    margin-bottom: 0.5em;
    color: white;
}

.text {
    margin: 0;
    color: white;
    font-weight: 600;
}

.products {
    padding: 1rem 0;
    column-width: 300px;
    column-gap: 1rem;
}

.product {
    margin-bottom: 1rem;
    break-inside: avoid;
    display: inline-block;
    width: 100%;
}

@media (min-width: $breakpoint-tablet) {
    .products {
        padding: 1.5rem 0;
        column-gap: 1.5rem;
    }

    .product {
        margin-bottom: 1.5rem;
    }
}
</style>
